/**
 * UserRole enum to define survey types
 */
export enum UserRole {
  ADMIN = 'admin',
  PARTNER_MANAGER = 'partnerManager',
  PARTNER_ACCESS = 'partnerAccess',
  SUPER_ADMIN = 'superAdmin'
}
